import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const MyRewards = React.lazy(() => import("./MyRewards"));
const RewardDetails = React.lazy(() => import("./RewardDetails"));
const IssueReward = React.lazy(() => import("./IssueReward"));
const RewardSettings = React.lazy(() => import("./RewardSettings"));
const ManageRewards = React.lazy(() => import("./ManageRewards"));
const Leaderboard = React.lazy(() => import("./Leaderboard"));
const EmailBrandingSettings = React.lazy(() => import("./EmailBrandingSettings"));

const rewardsModuleConfig: ModuleConfig = {
  id: "rewards",
  name: "Rewards",
  description: "BB Token reward system - issue, track, and redeem tokens",
  version: "1.0.0",
  enabled: true,
  category: "billing",
  order: 5,
  icon: "🎁",
  color: "#9333EA",
  routes: [
    {
      path: "/my-rewards",
      component: MyRewards,
      // No specific permissions - any authenticated user can access
      useLayout: true,
      layoutOptions: { maxW: "container.lg", py: 12 },
    },
    {
      path: "/rewards/:tokenId",
      component: RewardDetails,
      // Public route - no authentication required (for email links)
      public: true,
      useLayout: true,
      layoutOptions: { maxW: "container.md", py: 8 },
    },
    {
      path: "/rewards/issue",
      component: IssueReward,
      permissions: ["REWARDS_ISSUE", "REWARDS_ADMIN", "ADMIN"],
      useLayout: true,
      layoutOptions: { maxW: "container.md", py: 12 },
    },
    {
      path: "/rewards/manage",
      component: ManageRewards,
      permissions: ["REWARDS_ADMIN", "ADMIN"],
      useLayout: true,
      layoutOptions: { maxW: "container.xl", py: 12 },
    },
    {
      path: "/rewards/settings",
      component: RewardSettings,
      permissions: ["REWARDS_ADMIN", "ADMIN"],
      useLayout: true,
      layoutOptions: { maxW: "container.lg", py: 12 },
    },
    {
      path: "/rewards/leaderboard",
      component: Leaderboard,
      public: true,
      useLayout: true,
      layoutOptions: { maxW: "800px", py: 16 },
    },
    {
      path: "/rewards/email-branding",
      component: EmailBrandingSettings,
      permissions: ["REWARDS_ADMIN", "ADMIN"],
      useLayout: true,
      layoutOptions: { maxW: "container.xl", py: 8 },
    },
  ],
  navigation: [
    {
      label: "My Rewards",
      path: "/my-rewards",
      icon: "🌸",
    },
    {
      label: "Issue Reward",
      path: "/rewards/issue",
      icon: "🎁",
      permissions: ["REWARDS_ISSUE", "REWARDS_ADMIN", "ADMIN"],
    },
    {
      label: "Manage Rewards",
      path: "/rewards/manage",
      icon: "📋",
      permissions: ["REWARDS_ADMIN", "ADMIN"],
    },
    {
      label: "Leaderboard",
      path: "/rewards/leaderboard",
      icon: "🏆",
    },
    {
      label: "Reward Settings",
      path: "/rewards/settings",
      icon: "⚙️",
      permissions: ["REWARDS_ADMIN", "ADMIN"],
    },
    {
      label: "Email Branding",
      path: "/rewards/email-branding",
      icon: "🎨",
      permissions: ["REWARDS_ADMIN", "ADMIN"],
    },
  ],
  permissions: {
    view: ["USER", "CLIENT", "REWARDS_VIEW", "REWARDS_ADMIN", "ADMIN"],
    create: ["REWARDS_ISSUE", "REWARDS_ADMIN", "ADMIN"],
    edit: ["REWARDS_ADMIN", "ADMIN"],
    delete: ["REWARDS_ADMIN", "ADMIN"],
  },
  quickActions: [
    {
      label: "View My Rewards",
      path: "/my-rewards",
      icon: "🌸",
      description: "Check your reward token balance",
    },
  ],
};

export default rewardsModuleConfig;
